import BasePMPExcludedPending from "../../basePMPExcluded/basePMPExcludedPending";

export default class ApprovePMPExcludedPending extends BasePMPExcludedPending {}
